























import { Component, Vue } from 'vue-property-decorator'
import PageWithHeaderFooter from '@/components/common/PageWithHeaderFooter.vue'
import RecoverPasswordForm from '@/components/register_login/RecoverPasswordForm.vue'
import OperationResultTips from '@/components/common/OperationResultTips.vue'

@Component({
  components: {
    PageWithHeaderFooter,
    RecoverPasswordForm,
    OperationResultTips
  }
})
export default class ForgetPassword extends Vue {
  private sendLinkSuccess: boolean = false

  /**
   * 发送密码重置链接成功
   */
  private sendResetLinkSuccessHandler () {
    this.sendLinkSuccess = true
  }
}
